import isEqual from "lodash/isEqual"
import { computed } from "vue"
import { mapState } from "vuex"
import { categories } from "@/lib/ListingFilters"

export default function useDisplayCount() {
  const filters = mapState("filter", {
    availability: ({ filters }) => filters.availability,
    ready_to_hang: ({ filters }) => filters.ready_to_hang,
    from_followeds: ({ filters }) => filters.from_followeds,
  })

  const availability = computed(filters.availability)
  const ready_to_hang = computed(filters.ready_to_hang)
  const from_followeds = computed(filters.from_followeds)

  const displaysLength = computed(() => {
    return [
      availability.value === "for_sale_web",
      ready_to_hang.value === "ready_to_hang",
      from_followeds.value === "from_followeds",
    ].filter((condition) => condition).length
  })

  return computed(() => ({
    badgeContent: displaysLength.value,
    badgeCondition: displaysLength.value,
  }))
}
